import React from 'react'
import { Chips } from 'primereact/chips'

export default function LtsChips(props) {
  const {
    onChange: onChangeProp,
    label,
    hidden,
    value = [],
    name,
    max,
    separator,
    allowDuplicate,
    style,
    disabled,
    className,
    placeholder,
    ...rest
  } = props

  const handleChange = (event) => {
    onChangeProp?.(event.value)
  }

  return (
    <span className="p-float-label">
      <Chips
        {...rest}
        value={value}
        onChange={handleChange}
        name={name}
        max={max}
        separator={separator}
        allowDuplicate={allowDuplicate}
        style={style}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
      />
      {label && !hidden && <label>{label}</label>}
    </span>
  )
}
